/**
 * Another member's profile view (docs/Decisions.md D42): their name and
 * ribbon rack, as this viewer is allowed to see it. Visibility is enforced
 * by GET /member-badges/rack/{userId}; group- and organization-only awards
 * never reach a viewer outside that group or organization.
 */
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { ui, cn } from '../lib/ui';
import { getUserRack } from '../api/ribbons';
import { ErrorAlert } from '../components/ui';
import RibbonRack from '../components/ribbons/RibbonRack';
import RecommendedServices from '../components/RecommendedServices';

export default function MemberProfile() {
  const { userId } = useParams();
  const [rack, setRack] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    setRack(null);
    setError(null);
    getUserRack(userId)
      .then(data => {
        if (!cancelled) setRack(data);
      })
      .catch(err => {
        if (!cancelled) setError(err);
      });
    return () => {
      cancelled = true;
    };
  }, [userId]);

  return (
    <div className={ui.page}>
      <h1 className={ui.h1}>{rack ? rack.displayName : 'Member profile'}</h1>
      <ErrorAlert error={error} />
      {!rack && !error && (
        <p className={ui.muted} role="status">
          Loading
        </p>
      )}
      {rack && (
        <>
          <p className={cn(ui.muted, 'mb-4')}>Ribbons and badges earned across the platform.</p>
          <RibbonRack rack={rack} />
        </>
      )}
      <RecommendedServices userId={userId} />
    </div>
  );
}
